import Image from 'next/image'
import {FC} from 'react'

import {getAboutUsContent} from '@/content/aboutUs'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'

import {Text, TextFontWeight, TextVariant} from '../common/content/Text'

export const ModernLegalServices: FC = () => {
  const {t} = useTranslation()
  const {title, imageSrc, imageAlt, techVision, humanTouch} = getAboutUsContent().modernServices

  return (
    <>
      <Text variant={TextVariant.h2} align="center">
        {t(title)}
      </Text>
      <div className="wrapper">
        <div className="content right">
          <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
            {t(techVision.title)}
          </Text>
          {techVision.descriptions.map((description) => (
            <div key={description} className="description">
              <Text color={theme.palette.text.light}>{t(description)}</Text>
            </div>
          ))}
        </div>
        <div className="image">
          <Image src={imageSrc} alt={imageAlt} fill style={{objectFit: 'contain'}} />
        </div>
        <div className="content">
          <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
            {t(humanTouch.title)}
          </Text>
          {humanTouch.descriptions.map((description) => (
            <div key={description} className="description">
              <Text color={theme.palette.text.light}>{t(description)}</Text>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          justify-content: space-between;
          margin-top: ${theme.spacing[8]};
        }
        .content {
          max-width: 340px;
        }
        .right {
          text-align: right;
        }
        .description {
          margin-top: ${theme.spacing[2.5]};
        }
        .description + .description {
          margin-top: ${theme.spacing[3]};
        }
        .image {
          position: relative;
          width: 100%;
          max-width: 390px;
          height: 390px;
          margin: 0 ${theme.spacing[5]};
          flex: 1;
        }
        @media ${TABLET_SCREENSIZE} {
          .content {
            max-width: 280px;
          }
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .wrapper {
            flex-direction: column;
            margin-top: ${theme.spacing[6]};
          }
          .content {
            max-width: 80%;
            text-align: center;
            margin: ${theme.spacing[6]} auto 0;
          }
          .image {
            order: -1;
            width: 315px;
            height: 300px;
            margin: 0 auto;
            flex: inherit;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .content {
            max-width: inherit;
            margin: ${theme.spacing[5]} auto 0;
          }
          .image {
            width: 210px;
            height: 200px;
          }
        }
      `}</style>
    </>
  )
}
